import type { RolePermissionSummary, RoleSummary } from "@autoflow/types";
import { http } from "../../shared/api/http";

export type RoleInput = { name: string; description?: string; permissionIds: string[] };
export type RoleUpdate = Partial<RoleInput> & { isActive?: boolean };

export const rolesApi = {
  list: async () => (await http.get<RoleSummary[]>("/v1/roles")).data,
  permissions: async () => (await http.get<RolePermissionSummary[]>("/v1/roles/permissions")).data,
  create: async (input: RoleInput) => (await http.post<RoleSummary>("/v1/roles",input)).data,
  update: async (id: string,input: RoleUpdate) => (await http.patch<RoleSummary>(`/v1/roles/${id}`,input)).data
};
